module.exports = __webpack_public_path__ + "static/media/thunderstrom.eda9e03a.ico";